export default "__VITE_ASSET__DFadCFTi__"